import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const fantasyWordList = [
  "arrow",
  "blade",
  "bow",
  "cosmic",
  "crown",
  "curse",
  "dawn",
  "dream",
  "echo",
  "epic",
  "gold",
  "guide",
  "hero",
  "hollow",
  "journey",
  "midnight",
  "moon",
  "mystery",
  "path",
  "rod",
  "secret",
  "shadow",
  "shield",
  "silver",
  "spell",
  "star",
  "sun",
  "treasure",
];

export const fantasyCollection: WordCollection = createCollection(
  "fantasy",
  "Fantasy & Mysticism",
  fantasyWordList,
  { icon: "script-text-outline", isWordlistViewable: true }, // Example icon, adjust as needed
);
